module.exports = __webpack_public_path__ + "img/EVREY.f92c8d43.png";